import {createContext, useContext} from 'react'

export const ExpandedRowsContext = createContext<{
  /**
   * A list of row IDs that are currently expanded. IDs not in the array are assumed to be collapsed.
   */
  expandedRows: Array<string>
  /**
   * Toggles the expanded state of a row by its ID.
   */
  toggleRowExpanded: (rowId: string) => void
} | null>(null)

export const useExpandedRows = () => {
  const ctx = useContext(ExpandedRowsContext)
  if (!ctx) throw new Error('useExpandedRows must be used within a ExpandedRowsContext')
  return ctx
}
